import { Action } from '../../actions';
import {
    CHANGE_FREELANCER_ACCEPT_POPUP_PHONE,
    FOCUS_FREELANCER_ACCEPT_POPUP_PHONE,
    REQUEST_COOP_BY_CUSTOMER_ERROR,
    REQUEST_COOP_BY_CUSTOMER_START,
    REQUEST_COOP_BY_CUSTOMER_SUCCESS
} from '../../actions/freelancers/freelancer-accept-popup';
import {
    CLOSE_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT,
    FREELANCER_CARD_UPDATE_CUSTOMER_PHONE,
    UPDATE_FREELANCER_CUSTOMER_DATA
} from '../../actions/freelancers/freelancer-card';
import { validatePhone } from '../../service/ValidationHelpers/ValidationHelpers';
import { FreelancerAcceptPopup, State } from '../../typings/state';

export const initialState = {
    isAcceptRequestPending: false,
    originPhone: '',
    lastValidPhone: '',
    editPhone: {
        inputVal: '',
        error: undefined,
        focused: undefined
    }
};

export const freelancerAcceptPopup = (
    state: FreelancerAcceptPopup = initialState,
    action: Action,
    fullState: State
): FreelancerAcceptPopup => {
    switch (action.type) {
        case REQUEST_COOP_BY_CUSTOMER_START:
            return {
                ...state,
                isAcceptRequestPending: true
            };
        case REQUEST_COOP_BY_CUSTOMER_SUCCESS:
            return {
                ...state,
                isAcceptRequestPending: false
            };
        case REQUEST_COOP_BY_CUSTOMER_ERROR:
            return {
                ...state,
                isAcceptRequestPending: false
            };
        case CHANGE_FREELANCER_ACCEPT_POPUP_PHONE:
            const phone = action.value;
            const validPhone = validatePhone({ inputVal: phone });

            return {
                ...state,
                editPhone: {
                    ...state.editPhone,
                    inputVal: phone,
                    error: validPhone.error
                },
                lastValidPhone: !validPhone.error ? validPhone.inputVal : state.lastValidPhone
            };
        case FOCUS_FREELANCER_ACCEPT_POPUP_PHONE:
            return {
                ...state,
                editPhone: {
                    ...state.editPhone,
                    focused: action.value
                }
            };
        case FREELANCER_CARD_UPDATE_CUSTOMER_PHONE:
            return {
                ...state,
                originPhone: action.value
            };
        case UPDATE_FREELANCER_CUSTOMER_DATA:
            const originPhone = (action.payload && action.payload.customer && action.payload.customer.phone) || '';

            return {
                ...state,
                originPhone,
                editPhone: { inputVal: originPhone },
                lastValidPhone: originPhone
            };

        case CLOSE_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT:
            return {
                ...state,
                editPhone: { inputVal: state.originPhone }
            };

        default:
            return state;
    }
};
